import React from 'react';
import NavItemFrame from '../primitives/NavItemFrame';
import NavRow from '../primitives/NavRow';
import { Tooltip } from '@frekuent/orbit/components';
import { ChevronDown } from '@/legacy/components/ui/Icons';

type SidebarTriggerItemProps = {
	text: string;
	variant?: 'default' | 'highlighted';
	size?: 'default' | 'collapsed';
	icon?: React.ReactNode;
	disabled?: boolean;
	onClick: () => void;
	expanded?: boolean;
	selected?: boolean;
};

const SidebarTriggerItem = ({
	text,
	onClick,
	variant = 'default',
	size = 'default',
	icon,
	disabled = false,
	expanded = false,
	selected = false,
}: SidebarTriggerItemProps) => {
	const chevron =
		size === 'collapsed' ? null : (
			<ChevronDown
				className={['transition-transform duration-200', expanded ? 'rotate-0' : '-rotate-90'].join(
					' ',
				)}
			/>
		);

	const content = () => (
		<NavItemFrame
			size={size}
			variant={variant}
			selected={selected}
			useIndicator={false}
		>
			<NavRow
				text={text}
				size={size}
				disabled={disabled}
				leftSlot={icon}
				rightSlot={chevron}
				className='text-tertiary'
			/>
		</NavItemFrame>
	);

	if (disabled) {
		return (
			<div
				aria-disabled='true'
				tabIndex={-1}
			>
				{content()}
			</div>
		);
	}

	return (
		<button
			className='block group p-0 m-0 w-full'
			onClick={onClick}
		>
			{size === 'collapsed' ? (
				<Tooltip
					content={text}
					placement='right'
					size='small'
				>
					<div className='w-fit'>{content()}</div>
				</Tooltip>
			) : (
				content()
			)}
		</button>
	);
};

export default SidebarTriggerItem;
